import { useTeamContext } from "@/topics/Recall/TeamContext"

export const useOwnTeam = () => {
    const { ownTeam, mutateOwnTeam } = useTeamContext()
    return { data: ownTeam, mutate: mutateOwnTeam }
}

export const useJoinedTeam = () => {
    const { joinedTeam, mutateJoinedTeam } = useTeamContext()
    return { data: joinedTeam, mutate: mutateJoinedTeam }
}
